export default __webpack_public_path__ + "static/core-collection-mobile-d20e7b9a6e7795ad2f61c1692beb098d.webp";